<template>
	<div>
		<div style="background:transparent;padding:0px;">
			<div v-if="this.category" class="flexcenter breadcrumbs"
				style="background:transparent;align-items:stretch;flex-wrap: wrap;"> <!-- hela listan -->

				<!-- varje kategori -->
				<div v-for="(category, index) in this.categoryPath" :key="category?.categoryId" style="padding:0px;margin-right:0px;">

					<!-- kategori namn-->
					<div class="flexcenter category link"
						style="padding:0px;margin-bottom:0px;border-radius: 5px;align-items: center;height:100%"
						@click="index == 0 ? setCategory(null) : selectCategory(category?.categoryId)">

						<div style="font-size: 100%;font-size:80%;font-weight:normal;text-decoration: underline;" class="">
							{{
						category.name
							}}</div>



					

						<div v-if="category.categoryList != null"
							style="background:white;width:15px;height: 20px;justify-content: center;" class="flexcenter">
							<Icon fileName="w3_chevron_right_dark" style="width:6px;height:8px;" />
						</div>


					</div>

				</div>
			</div>
		</div>
	</div>
</template>
<script>


import categoryHelper from '@/helper/category-helper';
import { STORE_GETTER } from '../../../store/store';
import { categoryMixin } from '@/mixins/categoryMixin';

export default {
	name: "SelectCategoryBR3",
	components: {},
	mixins: [categoryMixin],
	props:{
		categoryModel:Object,
		category:Object,
		showArrow:{
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			//category: null,
			selectedCategoryInList: null,
			showCategoryId: null,
		};
	},
	computed: {

		



		categoryList() {

			//onst baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (this.categoryModel && this.categoryModel.categoryList) {
				return this.categoryModel.categoryList
			}

			return null;
		},

		categoryTree() {

			//const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (this.categoryModel && this.categoryModel.categoryTree) {
				return this.categoryModel.categoryTree
			}

			return null;
		},

		categoryPath() {

			return categoryHelper.getCategoryPath(this.categoryTree, this.category);

			

		},

		prouductCountList() {

			const productCountList = this.$store.getters[STORE_GETTER.CATEGORY_PRODUCT_COUNT_LIST];
			return productCountList;
		},


		

	},

	methods: {

		prouductCountLabel(category) {

			const count = this.prouductCountList[category.categoryId];

			if (count && count > 0) {
				return count + ""
			}

			return "--";

		},


		setCategory(category){
			this.$emit("categorySelected", category)
		},
	
		selectCategory(categoryId) {
		

			if (categoryId == 3) {
				this.setCategory(null);
				return;
			}

			const category = categoryHelper.findInCategoryTree(categoryId, this.categoryTree);

			if (category) {
				this.setCategory(category);
			}

			console.log('FP: category:', category);

		},

	
	




	},


};
</script>

<style scoped>
div.categoryArrow img.link {
	opacity: 0.2;
}

div.categoryArrow:hover img.link {
	opacity: 0.9;
}

div.breadcrumbs div.childCategoryList div.badge {
	background: var(--grey-4);
	color: var(--grey-dark-2);
}

</style>